'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import CanvasToolbarButton from 'rich-text-lib/components/toolbar/ToolbarButton';
import withSelectedState from '../hoc/withSelectedState';
import CharmapPopoverManager from '../components/CharmapPopoverManager';
import { i18nWithNameSpace } from '../utils/i18n';
import { INSERT_SPECIAL_CHARACTER, OPEN_SPECIAL_CHARACTER } from '../constants/usageTracking';
import { trackInteraction } from '../utils/usageTracking';
import { CANVAS_CHARMAP, CANVAS_CHARMAP_BUTTON } from '../constants/toolbar';
import { HS_CHARMAP } from '../constants/plugins';
import { jsx as _jsx } from "react/jsx-runtime";
const CanvasToolbarButtonWithSelectedState = withSelectedState(CanvasToolbarButton);
const openChangeKey = 'hsCharmapOpenChange';
const i18nKey = i18nWithNameSpace('TinymcePlugins.hscharmap');
export const addControls = (editor, getStoreHandlers) => {
  const handleInsert = charCode => {
    editor.insertContent(String.fromCharCode(charCode));
    trackInteraction(editor, 'tinymceCharmap', INSERT_SPECIAL_CHARACTER, {
      character: String.fromCharCode(charCode)
    });
  };
  const handleOpenChange = isOpen => {
    if (isOpen) {
      trackInteraction(editor, 'tinymceCharmap', OPEN_SPECIAL_CHARACTER);
    }
    editor.fire(openChangeKey, {
      selected: isOpen
    });
  };
  const handleClick = () => editor.fire('OpenCharmapPopover');
  tinymce.canvas.addMenuItem(editor, CANVAS_CHARMAP, {
    text: i18nKey('menuItem'),
    onClick: handleClick
  });
  tinymce.canvas.addButton(editor, CANVAS_CHARMAP_BUTTON, {
    renderControl: props => {
      const rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(CanvasToolbarButtonWithSelectedState, Object.assign({
        "data-test-id": "insert-special-character-button",
        iconName: "specialCharacter",
        tooltip: i18nKey('tooltip.insert'),
        onClick: handleClick,
        editor: editor,
        eventKey: openChangeKey
      }, rest));
    }
  });
  tinymce.canvas.addPopover(editor, HS_CHARMAP, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(CharmapPopoverManager, Object.assign({
        editor: editor,
        onOpenChange: handleOpenChange,
        onInsert: handleInsert,
        storeHandlers: getStoreHandlers(editor)
      }, renderProps));
    }
  });
};